import { Component, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { AppointmentService } from 'src/app/service/appointment.service';
import { PrescriptionService } from 'src/app/service/prescription.service';
import { UserService } from 'src/app/service/user.service';
import { MyLocalRxUserService } from 'src/app/service/my-local-rx-user.service';
import { Pharmacy } from 'src/app/shared/models/pharmacy.model';
import { DatePipe } from '@angular/common';
import { MatDialog, MatSnackBar } from '@angular/material';
import { NgForm } from '@angular/forms';
import { PharmacyService } from 'src/app/service/pharmacy.service';
import { OkOnlyComponent } from 'src/app/shared/view/ok-only/ok-only.component';
import { Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-view-appointmet-details',
  templateUrl: './view-appointmet-details.component.html',
  styleUrls: ['./view-appointmet-details.component.css']
})
export class ViewAppointmetDetailsComponent implements OnInit {
  assesment_status: string;
  assesmentId: string;
  currentAppointment_id: string;
  statusAppointment_id: string;

  constructor(private dialog: MatDialog, private userService: UserService, private datePipe: DatePipe, private _snackBar: MatSnackBar,
    private myLocalRxUserService: MyLocalRxUserService, private pharmacy: PharmacyService,
    private appointmentService: AppointmentService,private router: Router,) {

  }

  @Input() data: any;
  @Output() previewClose = new EventEmitter();
  isCardiaEnabled = false;
  ngOnInit() {
    this.statusAppointment_id = localStorage.getItem("appointment_id");
    console.log("AppointmentId=",this.statusAppointment_id)
    this.userService.getAssesmentStatus(this.statusAppointment_id).subscribe({
      next: abc => {
        // console.log('status',data.assessment_status,data)
        abc.forEach(element => {
          console.log('status',element.assessment_status,element)
          localStorage.setItem("assesment_status",element.assessment_status);
          localStorage.setItem("assesment_id",element.id)
          
        });
        
      }})
      console.log("DataPharmacybefore",this.data)
    this.data.pharmacy = (JSON.parse(localStorage.getItem("pharmacieList")) as Pharmacy[]).find(x => x.id == this.data.pharmacyID);
    console.log("after",this.data,this.data.pharmacy,this.data.appointment_mob)
    this.pharmacy.checkIsCardiaEnabled(this.data.pharmacy.id).subscribe(x => {
      this.isCardiaEnabled = x;
    });
    if (this.data.serviceProvider == 1) {
      this.isCardiaEnabled = true;
    }
    this.myLocalRxUserService.getPatientById(this.data.patientID).subscribe(x => {
      console.log("viewdetail patient=",x)
      // this.assesment_status = localStorage.getItem("assesment_status");
      // console.log("viewassesment_status=",this.assesment_status)
      if (x == null) {
        this.userService.getPatientById(this.data.patientID).subscribe(x => {
          this.data.ohip = x.ohip;
          this.data.sex = x.sex;
          this.data.email = x.email;
          if (!this.data.dateOfBirth) {
            this.data.dateOfBirth = x.dateOfBirth;
          }
        });
      } else {
        this.data.ohip = x.ohip;
        this.data.sex = x.sex;
        this.data.email = x.email;
        if (!this.data.dateOfBirth) {
          this.data.dateOfBirth = x.dateOfBirth;
        }
      }

    });
    var questionsId = this.data.serviceType == 0 ? "covid" : (this.data.serviceType == 1 ? "covid_asymptomatic_test" : this.data.serviceId);

    this.questions = [];
    if (this.data.questionnaire && this.data.questionnaire.length > 0) {
      $('.csLoader').css({ display: 'flex' });
      this.appointmentService.getQuestionnaire(questionsId).subscribe(x => {
        $('.csLoader').css({ display: 'none' });
        this.questions = [];
        this.data.questionnaire.forEach(element => {
          var qq = x.find(q => q.id == element.questionId);
          this.questions.push({ q: qq.question, a: element.answer });
        });
      }, (err) => {
        $('.csLoader').css({ display: 'none' });
      });
    }
  }

  close() {
    this.previewClose.emit(null);
    this.assesment_status=null;
    
  }

  showForm = false;
  passport_no = "";
  nationality = "";
  temp_dob = ["", "", ""];
  temp_appDate = [];
  test_reason = "";
  test_reason_type = "";
  viewCrtForm() {
    if (!this.isCardiaEnabled) {
      this._snackBar.open("CardiAI credential is missing.", "Error", {
        duration: 2000,
      });
      return;
    }
    this.test_reason = "";
    this.test_reason_type = "";
    this.passport_no = this.questions.find(x => x.q.toLowerCase().indexOf("passport number") > -1).a;
    this.nationality = this.questions.find(x => x.q.toLowerCase().indexOf("nationality ") > -1).a;
    if (this.data.dateOfBirth) {
      this.temp_dob = this.data.dateOfBirth.split('/');
    }
    this.temp_appDate = this.datePipe.transform(this.data.startTime, "MM/dd/yyyy").split('/');
    this.showForm = true;
  }


  startAssesment() {
    this.assesmentId = localStorage.getItem("assesment_id")
    this.currentAppointment_id = localStorage.getItem("appointment_id");
    console.log("currentAppointment_id=",this.currentAppointment_id);
    this.assesment_status = "In Process"
    this.userService.updateAssesmentstatus(this.assesmentId,this.currentAppointment_id,this.assesment_status).subscribe(resultData => {
      console.log('result updateStatusofBookedMinorailments=', resultData);
  })
  this.router.navigate(['/minor-ailments']);
}




  generateCertificate(form: NgForm) {

    if (form.valid) {

      var data = {
        "basicInfo": {
          "appointment_date": this.temp_appDate[2] + "-" + this.temp_appDate[0] + "-" + this.temp_appDate[1], // "2021-09-22",
          "test_type": "031217a0-2ea3-11eb-81d1-314696e9bed3",
          "adult": "1",
          "children": "0",
          "booking_time": this.datePipe.transform(this.data.startTime, "hh:mm"),
        },
        "userInfo": {
          "adult": [
            {
              "first_name": this.data.firstName,
              "last_name": this.data.lastName,
              "gender": this.data.sex == 0 ? 'male' : 'female',
              "date": this.temp_dob[1],
              "month": this.temp_dob[0],
              "year": this.temp_dob[2],
              "address": this.data.address2.streetAddress,
              "province": "",
              "email": this.data.email,
              "phone": this.data.phoneNumber,
              "phn": null,
              "nationality": this.nationality,
              "passport_no": this.passport_no,
              "test_reason": this.test_reason,
              "test_reason_type": this.test_reason_type
            }
          ],
          "child": [

          ]
        },
        "billing": {
          "first_name": this.data.firstName,
          "last_name": this.data.lastName,
          "address": this.data.address2.streetAddress,
          "city": this.data.address2.city,
          "province": "",
          "postal_code": "2",//this.data.address2.postalCode,
          "phone": this.data.phoneNumber,
          "email": this.data.email,
          "payment_type": "cash",
          "amount": 10,

        }
      };

      console.log(data);
      this.appointmentService.generateCardiaCertificate(data, this.data.id).subscribe(x => {
        if (x.errorMessage) {
          this._snackBar.open(x.errorMessage, "Error", {
            duration: 2000,
          });
        }
        else {
          this.showForm = false;
          this.data.updateCardia = true;
          this.data.cardiaId = this.data.serviceProvider == 0? x.data.appointment_unique_id:x.data.order_number;
          this.previewClose.emit(this.data);
          this._snackBar.open(x.successMessage, "Success", {
            duration: 2000,
          });
        }
      });
    }
    else {
      this._snackBar.open("Please fill details", "Error", {
        duration: 2000,
      });
    }
  }
  updateStatus(status: string) {
    if (!this.isCardiaEnabled) {
      this._snackBar.open("CardiAI credential is missing.", "Error", {
        duration: 2000,
      });
      return;
    }
    console.log(this.data.cardiaId,this.data.id,status);
    this.appointmentService.updateStatus(this.data.cardiaId, this.data.id, status).subscribe(x => {
      if (x.errorMessage) {
        this._snackBar.open(x.errorMessage, "Error", {
          duration: 2000,
        });
      }
      else {
        if (x.data.status == "Success") {
          this.data.updateCardia = true;
          this.data.cardiaStatus = status;
          this.previewClose.emit(this.data);
        }
        this._snackBar.open(x.data.msg, "Success", {
          duration: 2000,
        });
      }
    });
  }
  getCardiaStatus() {
    $('.csLoader').css({ display: 'flex' });
    this.appointmentService.getCardiaStatus(this.data.id).subscribe(x => {
      $('.csLoader').css({ display: 'none' });
      // x = this.tempResult();
      if (x.errorMessage) {
        this._snackBar.open(x.errorMessage, "Error", {
          duration: 2000,
        });
      }
      else {
        if (x.data.msg) {
          this._snackBar.open(x.data.msg, "Error", {
            duration: 2000,
          });
        }
        else {
          this.dialog.open(OkOnlyComponent, {
            width: "420px",
            data: {
              title: "Test Status",
              message: this.getResultHTML(x.data),

            }
          });
        }
      }
    });
  }


  getResultHTML(data: any): string {
    var html = `<table class='cardiAiResult'>`;
    html += `<tr><th>Booking date</th><td> ${data.testReport["first_name"]}  ${data.testReport["booking_date"]}</td></tr>`;
    html += `<tr><th>Booking time</th><td> ${data.testReport["first_name"]}  ${data.testReport["booking_time"]}</td></tr>`;
    html += `<tr><th>Status</th><td> ${data.testReport["status"]}</td></tr>`;

    if (data.result_pdf) {
      html += `<tr><th>Result</th><td>${data.result_pdf["result1"]}</td></tr>`;
      html += `<tr><th>URL</th><td><a target="_blank" href="${data.result_pdf["result_pdf"]}"> Click here...</td></tr>`;
    }
    html += "<table>";
    return html;
  }
  // tempResult(): any {
  //   var ss = JSON.parse(`{"testReport":{"id":"e4804660-32a6-11ec-9a40-d9ec1c49e15c","first_name":"JEYASAKTHY","last_name":"SURENDRA","email":"surendra.jeya@gmail.com","phone":"+16475228596","booking_date":"2021-10-21","booking_time":"11:10","adults":"1","children":"0","test_type":["type1"],"is_appointment_booked":1,"is_refunded":0,"invoice_url":null,"refund_invoice":null,"created_by":112,"booked_by":112,"is_final_report_sended":0,"lab_id":67,"company_id":112,"status":"completed","api_token":"cHVsc2VpZGFwaGFybWFjeUBnbWFpbC5jb20=","is_api":1,"created_at":"2021-10-21T23:40:57.000000Z","updated_at":"2021-10-21T23:40:57.000000Z","test_style_class":"bg-primary","test_name_info":"PCR Covid-19 Test (Results < 24hr)","guest_details":[{"id":"e480b0b0-32a6-11ec-a3c0-c79dfaed7a0f","appointment_id":"e4804660-32a6-11ec-9a40-d9ec1c49e15c","first_name":"JEYASAKTHY","last_name":"SURENDRA","gender":"female","dob":"1963-04-17","address":"6, Hadfield Circle, Brampton L6R 0M7","province":"ON","phn":null,"phone":"+16475228596","email":"surendra.jeya@gmail.com","nationality":"CANADIAN","is_adult":1,"covid_concent":null,"concent_pdf":null,"refrence_key":40045,"chart_no":"ON40045","test_reason":"travel","test_reason_type":"it","passport_no":"HK885254","created_at":"2021-10-21T19:41:32.000000Z","updated_at":"2021-10-21T19:41:32.000000Z"}]},"result_pdf":{"id":"e6f5a7c0-32a6-11ec-ba1b-917f1746f583","app_id":"e4804660-32a6-11ec-9a40-d9ec1c49e15c","guest_id":"e480b0b0-32a6-11ec-a3c0-c79dfaed7a0f","test_id":"031217a0-2ea3-11eb-81d1-314696e9bed3","app_status":"completed","result1":"negative","result2":null,"result_pdf":"https:\/\/dev-cardio.s3.ca-central-1.amazonaws.com\/1634852464550621.pdf","is_final_report_sended":1,"igg":null,"igm":null,"ratio":null,"specimen_type":1,"report_setting_id":null,"created_at":"2021-10-21T23:40:57.000000Z","updated_at":"2021-10-21T21:55:37.000000Z","test_style_class":"bg-primary"},"billing":{"id":"e4877d20-32a6-11ec-8ed5-d97a880c7ae7","appointment_id":"e4804660-32a6-11ec-9a40-d9ec1c49e15c","address":"6, Hadfield Circle, Brampton L6R 0M7","city":"Brampton","province":"","postal_code":"2","transaction_hist_id":"e4872880-32a6-11ec-b544-e920b5c95969","coupon_applied":null,"coupon_company":null,"coupon_value":null,"coupon_type":null,"created_at":"2021-10-21T19:41:32.000000Z","updated_at":"2021-10-21T19:41:32.000000Z"}}`);
  //   return { data: ss };
  // }

  questions = [{ q: `Have you been sick in the past few days? Do you have symptoms of COVID-19 or have a fever today?`, a: 'No' }, { q: `Have you had a serious allergic reaction or a reaction within 4 hours to the COVID-19 vaccine before?`, a: 'No' }, { q: `Do you have allergies to polyethylene glycol [PEG]*, tromethamine (Moderna only) or polysorbate?`, a: 'No' }, { q: `Have you had a serious allergic reaction to a vaccine or medication given by injection (e.g., IV, IM), needing medical care?`, a: 'No' }, { q: `Have you received a vaccine in the past 14 days?`, a: 'No' }, { q: `Are you or could you be pregnant or breastfeeding?`, a: 'No' }, { q: `Do you have a weakened immune system or are you taking any medications that can weaken your immune system (e.g., high dose steroids, chemotherapy)?`, a: 'No' }, { q: `Do you have an autoimmune condition?`, a: 'No' }, { q: `Do you have a bleeding disorder or are taking blood thinning?`, a: 'No' }, { q: `Have you ever felt faint or fainted after receiving a vaccine or medical procedure?`, a: 'No' }, { q: `Do you have allergic rhinitis asthma or eczema?`, a: 'No' }];

}

